import React, { FC } from 'react'

import { ComponentMediaTextVariants } from '../../../models/components/mediaTextVariants'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'
import Typography from '../typography'
import { MediaTextVariantsOuter } from './style'
import { renderMediaTextVariant } from './subcomponents/mediaTextParts'

type Props = {
  data: ComponentMediaTextVariants
  pageType?: string
}

const MediaTextVariants: FC<Props> = ({ data, pageType = '' }) => {
  if (!data) return null

  const { headline, body, anchorLink, orangeDivider, topPadding, bottomPadding } = data

  const useCaseData = {
    useCase: data?.useCase || '',
    accordionsLayout: data?.accordionsLayout || [],
    tabsLayout: data?.tabsLayout || [],
    columnsLayout: data?.columnsLayout || [],
    mainImgPath: data.mainImage?.image?.file?.url || '',
    mainImgAlt: data.mainImage?.altText || '',
  }

  return (
    <>
      {anchorLink?.identifier ? <span id={anchorLink?.identifier}></span> : null}
      <MediaTextVariantsOuter
        $orangeDivider={orangeDivider || false}
        $topPadding={topPadding || 'None'}
        $bottomPadding={bottomPadding || 'None'}
        $pageType={pageType || ''}
        data-cy="media-text-variants"
        className="MediaTextVariant">
        <div className="MediaTextV__Container">
          <div className="Orange__Divider"></div>
          <div className="MediaTextV__MainContent">
            <Typography type="header2" className="headline">
              {formatInlineCode(headline)}
            </Typography>
            {body && (
              <Typography type="bodyXL" className="desc">
                {renderRichText(body)}
              </Typography>
            )}
          </div>
          {renderMediaTextVariant({ useCaseData }, pageType)}
        </div>
      </MediaTextVariantsOuter>
    </>
  )
}

export default MediaTextVariants
